import config from '../clientConfig'
import Crypto from 'crypto-js';

const LOGGED_IN_USER = 'loggedInUser'; //could obfuscate this in the future

let UserStorage = {}

const TOKEN_KEY_HASHED = Crypto.SHA256('token' + config.apiBaseUrl).toString()

UserStorage.setAccessToken = (token) => {
    localStorage.setItem(TOKEN_KEY_HASHED, token);
}

UserStorage.getAccessToken = () => {
    return localStorage.getItem(TOKEN_KEY_HASHED);
}

UserStorage.clearToken = function clearToken() {
    localStorage.removeItem(TOKEN_KEY_HASHED);
}

UserStorage.setLoggedInUser = (username) => {
    localStorage.setItem(LOGGED_IN_USER, username);
}

UserStorage.getLoggedInUser = () => {
    return localStorage.getItem(LOGGED_IN_USER);
}

UserStorage.clearLoggedInUser = () => {
    localStorage.removeItem(LOGGED_IN_USER);
}

UserStorage.isAuthenticated = function isAuthenticated() {
    return !!this.getAccessToken();
}

export default UserStorage;